let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fDJqh")).then(() => parcelRequire('dx7Jv'));